<template>
  <RecordListPreview v-bind="previewProps" empty-label="站点选择网格" />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import RecordListPreview from '../../RecordListPreview.vue'
import type { WidgetPreviewProps } from '../../types'

const props = defineProps<WidgetPreviewProps>()
const previewProps = computed(() => props)
</script>
